import { render, staticRenderFns } from "./automated-statements.vue?vue&type=template&id=117a674a&scoped=true"
import script from "./automated-statements.vue?vue&type=script&lang=js"
export * from "./automated-statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a674a",
  null
  
)

export default component.exports